import { supabase } from '../helper/supabaseClient';

function cleanCommunity(row) {
  return {
    id: row.id,
    country: row.country ?? null,
    name: row.name ?? '',
    communityType: row.community_type ?? null,
    isActive: Boolean(row.is_active),
    sortOrder: row.sort_order ?? 0,
    createdAt: row.created_at ?? null,
    updatedAt: row.updated_at ?? null,
  };
}

/**
 * Active communities, optionally filtered by country (must match `communities.country` in DB).
 * Sorted: sort_order asc, then created_at desc.
 */
export async function getCommunities(country) {
  let query = supabase
    .from('communities')
    .select('id, country, name, community_type, is_active, sort_order, created_at, updated_at')
    .eq('is_active', true);

  if (country != null && String(country).trim() !== '') {
    query = query.eq('country', String(country).trim());
  }

  const { data, error } = await query
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: false });

  if (error) {
    throw new Error(error.message || 'Failed to load communities');
  }

  return (data ?? []).map(cleanCommunity);
}

/** Single community row for display (e.g. resolving name from id). */
export async function getCommunityById(id) {
  if (!id) return null;
  const { data, error } = await supabase
    .from('communities')
    .select('id, country, name, community_type, is_active, sort_order, created_at, updated_at')
    .eq('id', id)
    .maybeSingle();

  if (error) throw new Error(error.message || 'Failed to load community');
  return data ? cleanCommunity(data) : null;
}

